export const vi_tri = {
  HOME_TOP_SLIDERS_MTA: "home-top-sliders-mta",
};

export const slug = {
  HOMEPAGE: "trang-chu-website-viet-thien",
  NEWS: "trang-tin-tuc-website-viet-thien",
};
export const collection_name = {
  APP: "app",
  ECOM_PRODUCT_LINES: "ecomproductlines",
  NEWS: "news",
  ECOM_BANNERS: "ecombanners",
  ECOM_PAGES: "ecompages",
  FOOTER: "footer",
  ECOM_CONTACTUS: "ecomcontactus",
  PRODUCTS: "dmvt",
  CATEGORIES: "ecomcategories_cty",
  PRODUCT_GROUPS: "dmnvt",
};

export const type = {
  COUNT: "count",
  LIST: "list",
  DETAIL: "detail",
};
export const staleTime = {
  DEFAULT: 1000 * 60 * 1, // 1 minute
  LONG: 1000 * 60 * 5, // 5 minutes
  SHORT: 1000 * 60 * 10, // 10 seconds
};
